const tech_img = require("../../assets/img/tutorials/retiro/tech.png");
const secondary_tech_img = require("../../assets/img/tutorials/retiro/secondary-tech.png");
const func_img = require("../../assets/img/tutorials/retiro/func.png");
const secondary_func_img = require("../../assets/img/tutorials/retiro/secondary-func.png");

export const RetiroSteps = [
  {
    name: "Inventario de Ciudad",
    title: "Descripción funcional",
    description: (
      <span>
        <p>
          El gemelo digital permite integrar el resultado de{" "}
          <b>
            sistemas avanzado de captura de información a través de cámaras
            instaladas en vehículos que recorren el espacio público
          </b>
          .
        </p>
        <p>
          A través de este sistema de visión artificial, es posible{" "}
          <b>
            identificar y catalogar automáticamente una amplia gama de activos
            urbanos
          </b>
          , como señales de tráfico, mobiliario urbano, elementos de la
          infraestructura vial, y otros puntos de interés.
        </p>
        <p>
          La integración de esta tecnología permite no solo un inventario
          detallado y actualizado de los activos urbanos, sino también el
          análisis de su estado y uso. La recogida de datos puede ser
          enriquecida aún más con la{" "}
          <b>inclusión de información de tráfico en tiempo real</b>,
          proporcionando una visión completa del dinamismo de la ciudad con el
          objetivo de aplicar casos de uso de gestión de activos, planificación
          urbana, innovación en servicios ciudadanos, etc.
        </p>
      </span>
    ),
    secondarydescription: (
      <span>
        <p>
          Área de Gobierno de Vicealcaldía, Portavoz, Seguridad y Emergencias
        </p>
      </span>
    ),
    mainimage: <img src={func_img} alt="main_func" />,
    secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
  },
  {
    name: "Inventario de Ciudad",
    title: "Descripción técnica",
    description: (
      <div>
        <span>
          Integraciones técnicas
          <ul>
            <li>
              <b>Integración de Cartografía 2D y 3D</b>, permitiendo una
              representación detallada del espacio urbano y la interpretación de
              patrones geoespaciales.
            </li>
            <li>
              Uso de <b>nubes de puntos de alta resolución</b> proporcionadas
              para el mapeo detallado y análisis del espacio urbano, facilitando
              la gestión de infraestructuras y activos.
            </li>
          </ul>
        </span>
        <span>
          Origen de Datos
          <ul>
            <li>
              Integración de archivos con <b>datos vectoriales</b> geoespaciales
              esenciales para la cartografía y análisis territorial.
            </li>
            <li>
              Conexión con APIs para obtener{" "}
              <b>valores actualizados detráfico</b>, que permiten un seguimiento
              y gestión en tiempo real de la circulación vehicular.
            </li>
            <li>
              <b>Utilización de APIs</b> específicas para visualizar y analizar
              la intensidad del tráfico, contribuyendo a la optimización del
              flujo vehicular y la seguridad vial.
            </li>
          </ul>
        </span>
      </div>
    ),
    mainimage: <img src={tech_img} alt="main_tech" />,
    secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
  },
];
